import {Expose, Type} from 'class-transformer';
import {AbstractApiModel} from './abstract.api.model';

export class PlaceCategoryApiModel extends AbstractApiModel {
  @Expose() id: number;
  @Expose() slug: string;
  @Expose() name: string;
  @Expose() icon?: string;
  @Expose() color?: string;
  @Expose() sortOrder: number;
  @Expose() parentSlug?: string;
}
